import { queryOptions, useQuery } from "@tanstack/react-query";
import type { GetV1LinksByProfileLinkResponse } from "../../client";
import {
  getV1JobsOptions,
  getV1LinksByProfileLinkOptions,
  getV1MultipleJobsOptions,
} from "../../client/@tanstack/react-query.gen";
import { jsonParse } from "../utils/parse";
import type { QueryConfig } from "../utils/query-config";

export const useGetMulitpleBackgroundJobs = (
  profileIds: string[],
  type: string,
  enabled: boolean,
  opts?: { refetchInterval?: number | false },
) =>
  useQuery({
    ...getV1MultipleJobsOptions({ query: { profileIds: profileIds, type } }),
    enabled: enabled,
    staleTime: 0,
    ...opts,
  });
